import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import actionCreators from 'actions/creators';
import { DialogStyle } from 'stylecomponents';
import CupoyRouter from "components/commons/router/CupoyRouter";

class LogoutDialog extends Component {

	constructor(props) {
        super(props);

        this.showLogoutAlert = this._showLogoutAlert.bind(this);
        this.closeLogoutModal = this._closeLogoutModal.bind(this);
        this.logout = this._logout.bind(this);
    }

    render() {

    	return (
    		<DialogStyle.Content
                className="confirm-modal"
                // style props
                width="360px"
                padding="0"
                borderRadius="3px"
                backgroundColor="#fff"
                // dialog props
                visible={true}
                animation="zoom"
                maskAnimation="fade"
                animationDuration={250}
                closable={false}
                maskClosable={!this.props.isLogouting}
                keyboard={true}
                onClose={this.closeLogoutModal}
            >
		        <div className="confirm-modal-content">
					<h3 className="title">確定登出？</h3>
					<div className="button-group">
						{this.props.isLogouting?
							<div className="button blue submit disable">登出中</div>
							:
							<div className="button blue submit" onClick={this.logout}>確定</div>
						}
						<div className="button" onClick={this.closeLogoutModal}>取消</div>
					</div>
		        </div>                
            </DialogStyle.Content>
    	)
    }

    _logout() {

    	this.props.adminActions.logout().then(() => {
			this.closeLogoutModal();
            this.props.webActions.cupoyStateGo(CupoyRouter.STATES.LOGIN);
		}, () => {
			this.closeLogoutModal();
			this.props.webActions.cupoyStateGo(CupoyRouter.STATES.LOGIN);
		});
    }

   	_closeLogoutModal() {

   		if(this.props.isLogouting) {
   			return;
   		}

   		this.props.webActions.closeLogoutModal();
   	}

    _showLogoutAlert() {

        this.props.webActions.showLogoutModal();
    }
}

const mapStateToProps = function(state) {
    return {
        history: state.web.history,
        isLogouting: state.admin.isLogouting,
    };
};

const mapActionToProps = function(dispatch) {
    return {
        webActions: bindActionCreators(actionCreators.webActionCreators, dispatch),
        adminActions: bindActionCreators(actionCreators.adminActionCreators, dispatch)
    };
};

export default connect(mapStateToProps, mapActionToProps, null, {
    withRef: true
})(LogoutDialog);


// WEBPACK FOOTER //
// ./src/components/dialog/LogoutDialog.js